// import React from 'react';
// import { Form, Input, Button, Typography } from 'antd';
// import { motion } from 'framer-motion';
// import { Link } from 'react-router-dom';
// import './login.css';

// const { Title } = Typography;

// const Login = () => {
//   const onFinish = (values) => {
//     console.log('Login Success:', values);
//   };

//   return (
//     <motion.div
//       className="form-container"
//       initial={{ opacity: 0, y: 50 }}
//       animate={{ opacity: 1, y: 0 }}
//       transition={{ duration: 0.5 }}
//     >
//       <Title level={2} className="form-title">Login</Title>
//       <Form
//         name="login"
//         layout="vertical"
//         onFinish={onFinish}
//         className="form-content"
//       >
//         <Form.Item
//           label="Email"
//           name="email"
//           rules={[{ required: true, message: 'Please enter your email!' }]}
//         >
//           <Input />
//         </Form.Item>
        
//         <Form.Item
//           label="Password"
//           name="password"
//           rules={[{ required: true, message: 'Please enter your password!' }]}
//         >
//           <Input.Password />
//         </Form.Item>

//         <Form.Item>
//           <Button type="primary" htmlType="submit" block>
//             Log In
//           </Button>
//         </Form.Item>

//         <div className="form-footer">
//           Don't have an account? <Link to="/register">Register</Link>
//         </div>
//       </Form>
//     </motion.div>
//   );
// };

// export default Login;


import React from 'react';
import { Form, Input, Button, Typography } from 'antd';
import { Link } from 'react-router-dom';
import './login.css';
import loginImage from '../Asset/login1.png';

const { Title } = Typography;

const Login = () => {
  const onFinish = (values) => {
    console.log('Login Success:', values);
  };

  // Array of shape types
  const shapes = [ "triangle", "circle", "square", "star"];

  return (
    <div className="login-tech-wrapper">
      
      {/* 3D Glow Background */}
      <div className="background-animation"></div>

      {/* Repeated Floating Shapes - 3 times */}
      {[...Array(3)].map((_, index) => (
        shapes.map((shape, i) => (
          <div
            key={`${index}-${i}`}
            className={`floating-shape ${shape} shape-${i + 1}`}
            style={{
              animationDelay: `${Math.random() * 5}s`,
              top: `${Math.random() * 90}%`,
              left: `${Math.random() * 90}%`,
            }}
          >
            {shape === "star" && "★"}
          </div>
        ))
      ))}

      {/* Login Layout */}
      <div className="login-container">

        {/* Left Image */}
        <div className="login-image-section">
          <img src={loginImage} alt="Login Visual" className="login-image" />
        </div>

        {/* Right Login Card */}
        <div className="login-content">
          <Title level={2} className="login-title">Login</Title>
          
          <Form name="login" layout="vertical" onFinish={onFinish}>
            <Form.Item
              label="Email"
              name="email"
              rules={[{ required: true, message: 'Please enter your email!' }]}
            >
              <Input size="large" />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              rules={[{ required: true, message: 'Please enter your password!' }]}
            >
              <Input.Password size="large" />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" block size="large">
                Log In
              </Button>
            </Form.Item>

            <div className="login-footer">
              Don't have an account? <Link to="/register">Register</Link>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default Login;
